import { VenueReservation } from "@/graphql/operations";
import useDevice from "@/hooks/useDevice";
import Box from "@mui/material/Box";
import { Collapse } from "@mui/material";
import { useRef } from "react";
import { PendingReservationList } from "./PendingReservationList";

type PendingReservationsCollapseProps = {
  pendingReservations: VenueReservation[];
  pendingReservationsCount?: number;
  selectReservation: (reservationId: string) => void;
  selectedReservation: VenueReservation | null;
};

export function PendingReservationsCollapse({
  pendingReservations,
  pendingReservationsCount,
  selectReservation,
  selectedReservation,
}: PendingReservationsCollapseProps) {
  const { isMobile } = useDevice();
  const hasPendingReservations = pendingReservations.length > 0;
  const lastRenderedPendingReservationsRef = useRef(pendingReservations);
  const lastRenderedPendingReservationsCountRef =
    useRef(pendingReservationsCount);

  if (hasPendingReservations) {
    lastRenderedPendingReservationsRef.current = pendingReservations;
    lastRenderedPendingReservationsCountRef.current = pendingReservationsCount;
  }

  const renderedPendingReservations = hasPendingReservations
    ? pendingReservations
    : lastRenderedPendingReservationsRef.current;
  const renderedPendingReservationsCount = hasPendingReservations
    ? pendingReservationsCount
    : lastRenderedPendingReservationsCountRef.current;

  return (
    <Collapse
      data-testid="pending-reservations-collapse"
      in={hasPendingReservations}
      timeout="auto"
      unmountOnExit={true}
      sx={{
        minHeight: 0,
        flexShrink: 0,
        maxHeight: isMobile ? "none" : "100%",
        overflow: isMobile ? "visible" : "hidden",
      }}
    >
      <PendingReservationList
        reservations={renderedPendingReservations}
        pendingCount={renderedPendingReservationsCount}
        selectReservation={selectReservation}
        selectedReservation={selectedReservation}
      />
      <Box
        sx={{
          height: "4px",
          width: "100%",
          bgcolor: "divider",
        }}
      />
    </Collapse>
  );
}
